import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { NzTabChangeEvent } from 'ng-zorro-antd/tabs';
import { NotificationService } from 'src/app/services/notification.service';

@Component({
  selector: 'notification',
  templateUrl: './notification.component.html',
  styleUrls: ['./notification.component.less']
})
export class NotificationComponent implements OnInit {
  tabSelectedIndex: number = 0;
  notificationList:any[]=[];
  unReadNumber:any;
  @Output() handleCloseNotification: EventEmitter<number> = new EventEmitter<number>();

  constructor(private notificationService:NotificationService) { }
  ngOnInit(): void {
    this.getMessageList('');
  }
  getMessageList(bizType:string) {
    this.notificationService.getMessageList({current:1,size:-1,bizType:bizType}).subscribe(result=>{
      this.notificationList=result.rtnData.records;
    })
    this.getUnReadNumber();
  }
  onTabChange(event: NzTabChangeEvent) {
    let index = event.index;
    let bizType = (index==0?'':(index==1?'Achievement':(index==2?'Order':'Logistic')));
    this.getMessageList(bizType);
  }
  getUnReadNumber():void{
    this.notificationService.getUnReadNumber().subscribe(result=>{
      this.unReadNumber=result.rtnData;
    })
  }
  getUnReadNumberByType(messageUnReadVOList:any[],bizType:string):number{
    if(messageUnReadVOList){
      const achivementObj = messageUnReadVOList.find(item => item.bizType === bizType);
      return achivementObj? achivementObj.unReadCount:0;
    }else{
      return 0;
    }
   
  }
  handleClose(){
    //close modal
    this.handleCloseNotification.emit(this.unReadNumber.totalCount);
  }

}
